// extracted by mini-css-extract-plugin
module.exports = {"container":"+HDPn","content":"D34US","title":"SMfk1","info":"z+Lxx","divider":"U89ho","footer":"JlIbT"};